
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Format d'image Instagram 2026 : tailles optimales pour vos posts",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les tailles d’images recommandées pour Instagram en 2026 : assurez des publications nettes et attractives pour le feed, les stories et les reels.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Taille des images : Quel format d'image Instagram en 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Maîtrisez les formats Instagram 2026 : photos, vidéos et Reels. Optimisez votre visibilité et découvrez les meilleurs outils de redimensionnement",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
